<script setup>
import { ref, onMounted } from 'vue';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { setColorTheme } from 'dashboard/helper/themeHelper';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  isCollapsed: {
    type: Boolean,
    default: false,
  },
});

const isDark = ref(false);

onMounted(() => {
  isDark.value = document.body.classList.contains('dark');
});

function toggle() {
  isDark.value = !isDark.value;
  const newScheme = isDark.value ? 'dark' : 'light';
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, newScheme);
  setColorTheme(isDark.value);
}
</script>

<template>
  <Button
    :icon="isDark ? 'i-lucide-moon' : 'i-lucide-sun'"
    color="slate"
    size="sm"
    class="dark:hover:!bg-n-slate-9/30"
    :class="[
      isCollapsed
        ? '!size-8 !outline-n-weak !text-n-slate-11'
        : '!h-7 !w-7 !outline-n-weak !text-n-slate-11',
    ]"
    :title="isDark ? 'Tema claro' : 'Tema escuro'"
    @click="toggle"
  />
</template>
